import { Component } from '@angular/core';

@Component({
  selector: 'app-test-temp',
  templateUrl: './test-temp.component.html',
  styleUrls: ['./test-temp.component.scss'],
})
export class TestTempComponent {}
